/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Modals\ModalSearchCompany\ModalSearchCompany.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday January 16th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday January 16th 2024 10:43:30 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import translator from "MultiLanguage/TranslationWrapper";
import { MouseEventHandler, useState, FormEvent, Fragment, useEffect } from "react";
import {Form, Button} from "react-bootstrap";
import ModalConfirmation from "../ModalConfirmation/ModalConfirmation";
import MyModal from "../MyModal";
import Styles from "Content/Modals/ModalPartner/ModalPartner.module.css";
import FindCompany from "Content/Company/FindCompany/FindCompany";
import { CompanyDataType } from "Type/company.type";
import CompanyDisplay from "Content/Company/CompanyDisplay";

type ModalProps = {
    show: boolean;
    onClose: MouseEventHandler<HTMLDivElement>;
    closeModal: MouseEventHandler;
    title: string;
    submitFunc: Function;
    setCompany: Function;
    setCompanyID: Function;
    ClientID: string,
};

function ModalSearchCompany(props: ModalProps) {
    const [newCompany, setNewCompany] = useState<CompanyDataType | undefined>(undefined);
    const [isSendable, setIsSendable] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);

    useEffect(() => {
        if (newCompany)
            setIsSendable(true);
        else
            setIsSendable(false);
    }, [newCompany]);

    const HandleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsOkay(false);
        setSpinner(true);
        if (newCompany?.id) {
            await props.submitFunc(props.ClientID, {CompanyID: newCompany?.id }).then(() => {
                setIsOkay(true);
                props.setCompany(newCompany.Name);
                props.setCompanyID(newCompany.id)
            }).catch(() => {});
            setOpenModal(true);
        }
        setSpinner(false);
    };

    const handleCloseModalConfirm = () => {
        setOpenModal(false);
        setNewCompany(undefined);
    };

    return(
        <Fragment>
            <MyModal closeModal={props.closeModal} show={props.show} addCloseCross={true} onClose={props.onClose} footer={(() => { return (<></>); })()} title={props.title} className={`${Styles.modal}`}>
                {
                    spinner ?
                        <div className={`${Styles.spinnerHolder}`}>
                            <LoadingScreen />
                        </div>
                        :null
                }
                <Form className={`${Styles.formHolder}`} onSubmit={HandleSubmit}>
                    <FindCompany setCompany={setNewCompany} />
                    {newCompany ?
                        <CompanyDisplay {...newCompany} />
                    :null}
                <Button disabled={!isSendable} className="mb-3" type="submit">{translator.decode("dynamic.save")}</Button>
                </Form>
            </MyModal>
            <ModalConfirmation show={openModal} onClose={handleCloseModalConfirm} closeModal={handleCloseModalConfirm} isOkay={isOkay} />
        </Fragment>
    )
}

export default ModalSearchCompany;
